/**
 * @file
 */

/* global google */
/* global spireAttach */

(function ($) {

  'use strict';

  Drupal.locations = {};

  /**
   * Decimal adjustment of a number.
   *
   * @param {String}  type  The type of adjustment.
   * @param {Number}  value The number.
   * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
   * @returns {Number} The adjusted value.
   */
  function decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // If the value is negative...
    if (value < 0) {
      return -decimalAdjust(type, -value, exp);
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
  }

  // Decimal round
  if (!Math.round10) {
    Math.round10 = function (value, exp) {
      return decimalAdjust('round', value, exp);
    };
  }
  // Decimal floor
  if (!Math.floor10) {
    Math.floor10 = function (value, exp) {
      return decimalAdjust('floor', value, exp);
    };
  }
  // Decimal ceil
  if (!Math.ceil10) {
    Math.ceil10 = function (value, exp) {
      return decimalAdjust('ceil', value, exp);
    };
  }


  var MapStateEnum = {
    READY: 'ready',
    LOADING: 'loading',
    NO_RESULTS: 'no-results',
    ERROR: 'error'
  };

  Drupal.locations.MapLocation = function (data) {
    this.lat = parseFloat(data['lat']);
    this.lng = parseFloat(data['lng']);
    this.other = data['other'];
    this.id = data['id'];
    this.selected = false;
    this.marker = null;

    this.openListingHtml = function () {
      return '';
    };

    this.closedListingHtml = function () {
      return '';
    };

    this.getListing = function () {
      return '<div class="closed-data">'
        + this.closedListingHtml()
        + '</div><div class="open-data">'
        + this.openListingHtml() + '</div>';
    };

    this.getDistance = function (unit) {
      if (typeof unit === 'undefined' || unit == null) {
        unit = 'meters';
      }
      var d = this.distance;

      if (unit === 'miles') {
        d = (d / 1609.344);
      }

      return d;
    };

    this.getMarker = function (map) {
      if (this.marker === null) {
        var marker = new google.maps.Marker({
          position: {
            lat: this.lat,
            lng: this.lng
          },
          map: map,
          icon: this.smallMarkerIcon
        });
        this.marker = marker;
      }
      this.marker.setMap(map);

      return this.marker;
    };

    this.selectMarker = function (selected) {
      this.selected = selected;
      this.marker.setIcon(this.bigMarkerIcon);
    };

    this.unselectMarker = function () {
      this.selected = false;
      this.marker.setIcon(this.smallMarkerIcon);
    };

    this.eventMouseout = function () {
      if (this.selected === false) {
        this.unselectMarker();
      }
    };

    this.eventMouseover = function () {
      this.selectMarker(false);
    };

    this.smallMarkerIcon = {
      path: 'M2.31610846,2.31532089 C5.40658904,-0.77177363 10.4148962,-0.77177363 13.5030408,2.31532089 C16.5911854,5.40241541 16.5911854,10.4113547 13.5030408,13.4984492 C10.4148962,16.5855437 5.40658904,16.5878789 2.31610846,13.4984492 C-0.772036153,10.4113547 -0.772036153,5.40241541 2.31610846,2.31532089 Z',
      fillColor: '#250E62',
      fillOpacity: 0.5,
      strokeColor: '#250E62',
      anchor: new google.maps.Point(8, 8),
      strokeWeight: 1,
      scale: 1
    };

    this.bigMarkerIcon = {
      path: 'M36.9465541,32.7340008 C42.9379555,24.708048 42.2870505,13.2929042 34.9964017,6.00217279 C26.9907824,-2.00072426 14.0111212,-2.00072426 6.00550188,6.00217279 C-1.28770954,13.2929042 -1.93861456,24.708048 4.05534942,32.7340008 L3.98615873,32.7340008 L20.4996705,58.067115 L37.0131822,32.7340008 L36.9465541,32.7340008 L36.9465541,32.7340008 Z M14.6082112,26.8650388 C11.2204299,23.4784095 11.2204299,17.9834626 14.6082112,14.5968333 C17.9985551,11.2102041 23.4928085,11.2102041 26.8805898,14.5968333 C30.2683711,17.9834626 30.2683711,23.4784095 26.8805898,26.8650388 C23.4928085,30.2516681 17.9985551,30.2542299 14.6082112,26.8650388 L14.6082112,26.8650388 Z',
      fillColor: '#E87322',
      fillOpacity: 1,
      anchor: new google.maps.Point(20, 54),
      strokeWeight: 0,
      scale: 1
    };

  };


  /**
   * Constructs a map object.
   *
   * Provides a Google Map with listings.
   *
   * @constructor
   *
   * @param {HTMLTableElement} container
   *   DOM object that has the map and listing.
   */
  var Map = function (container, settings) {
    this.$container = container;
    this.$map = jQuery('.map', this.$container);
    this.map = null;
    this.locations = [];
    this.locationsById = {};

    this.settings = {
      zoom: 12,
      locationConstructor: Drupal.locations.MapLocation
    };

    this.settings = $.extend(this.settings, settings);

    this.mapStyle = [
      {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#666666"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "landscape",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
          {
            "saturation": -40
          },
          {
            "lightness": 35
          },
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "on"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": [
          {
            "color": "#cccccc"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#FFFDBF"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#666666"
          }
        ]
      },
      {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#F2E573"
          }
        ]
      },
      {
        "featureType": "road.highway.controlled_access",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.icon",
        "stylers": [
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "transit.line",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "color": "#bfbfbf"
          }
        ]
      },
      {
        "featureType": "transit.station.rail",
        "elementType": "geometry",
        "stylers": [
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
          {
            "saturation": -40
          },
          {
            "lightness": 20
          }
        ]
      }
    ];

    this.clearLocation = function () {
      this.locations = [];
      this.locationsById = {};
    };

    this.clearMarkers = function () {

      for (var key in this.locations) {
        if (!this.locations.hasOwnProperty(key)) { continue; }
        var loc = this.locations[key];

        loc.marker.setMap(null);
      }

      var me = this;
      if (this.map !== null) {
        this.map.data.forEach(function (feature) {
          me.map.data.remove(feature);
        });
      }
    };

    /**
     * Remove state classes from the map.
     *
     * State classes control what's shown via CSS. No classes indicate the map is
     * in it's default state.
     */
    this.removeState = function () {
      for (var prop in MapStateEnum) {
        if (!MapStateEnum.hasOwnProperty(prop)) {
          continue;
        }

        var stateClass = 'state-' + MapStateEnum[prop];
        this.$container.removeClass(stateClass);
      }
    };

    /**
     * Set state class on the map.
     *
     * State classes control what's shown via CSS. No classes indicate the map is in
     * it's default state. Only one state can be active at a time. This method will
     * remove all states before setting the new one.
     *
     * State classes are prepended with "state-".
     *
     * Example: "sate-no-results"
     */
    this.setState = function (state) {
      this.removeState();

      var stateClass = 'state-' + state;
      this.$container.addClass(stateClass);
    };

    /**
     * Load the map and populate with data for a location.
     *
     * This will initiate the google map if it's not been built yet.
     *
     * This will call _getLocations() to get the Locations for locationData. Each
     * concrete implementation of this object should define _getLocations()
     * specific to the data of the map.
     *
     * @param locationData
     *   A dictionary of lat/lng for the location to load data from.
     */
    this.loadMapLocation = function (locationData) {
      var me = this;

      this.clearMarkers();
      this.clearLocation();

      this.setState(MapStateEnum.LOADING);

      this._getLocations(locationData, function (locations) {
        if (locations === null) {
          me.setState(MapStateEnum.ERROR);
          return;
        }

        if (locations === null) {
          me.setState(MapStateEnum.ERROR);
          return;
        }

        me.initGoogleMap(locationData);
        me.centerMap(locationData);

        for (var locationKey in locations) {
          if (!locations.hasOwnProperty(locationKey)) {
            continue;
          }

          me.addLocation(locations[locationKey]);
        }

        me.locationsLoaded();
        me.renderList();
        me.setState(MapStateEnum.READY);
        me.openMarker(me.locations[0]);
      });
    };

    this.locationsLoaded = function () {
    };

    this.renderList = function () {
      var listing = $('.listing', this.$container);
      var me = this;

      listing.html('');

      for (var key in this.locations) {
        if (!this.locations.hasOwnProperty(key)) { continue; }
        var loc = this.locations[key];

        var li = $('<li></li>');

        li.attr('data-id', loc.id);
        li.append(loc.getListing());
        listing.append(li);

        li.on('click', function (e) {
          var l = me.locationsById[$(this).attr('data-id')];
          me.openMarker(l);
        });
      }

      spireAttach(this.$container[0]);
    };

    this.closeAllMarkers = function () {
      $('.listing li', this.$container).removeClass('open');
      for (var key in this.locations) {
        if (!this.locations.hasOwnProperty(key)) { continue; }
        var loc = this.locations[key];

        loc.unselectMarker();
      }
    };

    this.openMarker = function (location) {
      this.closeAllMarkers();

      var li = $('li[data-id="' + location.id + '"]', this.$container);
      var listing = $('.listing', this.$container);
      li.addClass('open');

      listing.animate({
        scrollTop: li.offset().top - listing.offset().top + listing.scrollTop()
      });

      // Bounds may not be setup when the first marker is opened by default.
      // That case is fine. Just set center anyway.
      var bounds = this.map.getBounds();
      if (typeof bounds === 'undefined' || !bounds.contains(location.marker.getPosition())) {
        this.map.setCenter(location.marker.getPosition());
      }

      location.selectMarker(true);
    };

    /**
     * Add a MapLocation to the map.
     *
     * Adds a Google Maps marker to the Goolge Map and adds the location to an
     * array on the object called this.location.
     *
     * @param {MapLocation} location
     *   A MapLocation object with a marker and data.
     */
    this.addLocation = function (location) {
      this.locations.push(location);
      var marker = location.getMarker(this.map);
      var me = this;

      marker.addListener('click', function () {
        me.openMarker(location);
      });

      marker.addListener('mouseover', function () {
        location.eventMouseover();
      });

      marker.addListener('mouseout', function () {
        location.eventMouseout();
      });


      this.locationsById[location.id] = location;
    };

    /**
     * Initiate the Google Map.
     *
     * This will only be called once per map object. If a map has already been
     * initialized, this will do nothing.
     */
    this.initGoogleMap = function (data) {
      if (this.map === null) {
        var loc = {
          lat: data.location.coords.latitude,
          lng: data.location.coords.longitude
        };

        this.map = new google.maps.Map(this.$map[0], {
          zoom: this.settings.zoom,
          mapTypeControlOptions: {
            mapTypeIds: ['roadmap', 'satellite', 'styled_map']
          },
          mapTypeId: 'roadmap',
          center: loc
        });

        var me = this;
        this.map.addListener('zoom_changed', function (e) { me.mapEventZoomChanged(e); });
      }
    };

    /**
     * Center the map on coordinates and reset the zoom level to the default.
     */
    this.centerMap = function (data) {
      var loc = {
        lat: data.location.coords.latitude,
        lng: data.location.coords.longitude
      };

      this.map.setCenter(loc);
      this.map.setZoom(this.settings.zoom);
    };

    this.mapEventZoomChanged = function (event) {
    };

    this._getLocations = function (locationData, func) {
      func(null);
    };
  };

  Drupal.locations.LocationMap = Map;
}(jQuery));
